import React, { useState } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.css";

export default function TemperatureMetric(props) {
  const [unit, setUnit] = useState("celsius");
  function showCelsius(event) {
    event.preventDefault();
    setUnit("celsius");
  }

  function showFahrenheit(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }

  if (unit === "celsius") {
    return (
      <span>
        <span className="temperatureMetric">{props.celsius}</span>
        <span className="temperatureUnitPosition">
          <span>°C</span> |{" "}
          <a href="/" onClick={showFahrenheit} className="temperatureUnit">
            °F
          </a>
        </span>
      </span>
    );
  } else {
    let fahrenheit = (props.celsius * 9) / 5 + 32;
    return (
      <span>
        <span className="temperatureMetric">{fahrenheit}</span>
        <span className="temperatureUnitPosition">
          <a href="/" onClick={showCelsius} className="temperatureUnit">
            °C
          </a>{" "}
          | <span>°F</span>
        </span>
      </span>
    );
  }
}
